<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Gifts' : 'Deleted Gifts'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/gifts/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
                <!-- <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/gifts/upload"
                >
                  <v-icon dark> mdi-upload </v-icon>
                </v-btn> -->
              </section>
              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/gifts/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(gifts.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Gift</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <!-- <v-card-title v-if="gifts.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title> -->
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">
                        Category
                      </th>
                      <th class="text-left" style="min-width: none">Gift</th>
                      <th class="text-left">Quantity</th>
                      <th class="text-left">Special Gift</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="gifts.length != 0">
                    <tr
                      v-for="(gift, i) in gifts"
                      :key="`gift_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': gifts.length - 1 == i,
                      }"
                    >
                      <td>
                        <input type="checkbox" v-model="gift.is_selected" />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="gift.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Gift is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="gift.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ gift.gift_category ? gift.gift_category.name : "" }}
                      </td>
                      <td>{{ gift.name || "" }}</td>
                      <td>{{ gift.quantity || "" }}</td>
                      <td>
                        <v-switch
                          v-model="gift.is_special_gift"
                          color="primary"
                          :disabled="isUpdatingSpecialGift"
                          @change="updateSpecialGift(gift.id, gift.is_special_gift)"
                        ></v-switch>
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(gift.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Gift</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/gifts/${encryptIt(gift.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Gift</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(gift.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this gift</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_gift" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_gift = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_gift" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_gift = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "giftsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      gifts: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportGiftTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_gift: false,
      is_deleted_gift: false,
      is_select_all: false,
      isDeleteAll: false,
      is_restored_gift: false,
      isUpdatingSpecialGift: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`gifts?${query}`)
        .then((response) => {
          this.gifts = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_gift = true;
      await axios
        .post(`/gifts/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_gift = false;
          this.is_deleted_gift = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.gifts.forEach((gift) => {
        gift.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.gifts.forEach((gift) => {
        if (gift.is_selected) deleteallIds.push(gift);
      });
      await axios
        .post("/gifts/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
    async Restore_this(id) {
      this.restore_gift = true;
      await axios
        .post(`/gifts/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_gift = false;
          this.is_restored_gift = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    // //Generate Excel
    // async generateExcel() {
    //   this.isExcelLoading = true;
    //   this.filter.search_keyword = this.filter.search_keyword
    //     ? this.filter.search_keyword
    //     : "";
    //   this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
    //   this.filter.is_active = this.filter.is_active
    //     ? this.filter.is_active
    //     : "";
    //   let response = [];
    //   let query =
    //     "&role_id=2" +
    //     "&companyId=" +
    //     this.company.id +
    //     "&is_active=" +
    //     this.filter.is_active +
    //     "&search_keyword=" +
    //     this.filter.search_keyword;
    //   response = await axios
    //     .get(`/gifts/excel_export?${query}`)
    //     .then((response) => window.open(`${response.data.data}`, "_blank"));
    //   if (response) {
    //     console.log(response);
    //   }
    //   this.isExcelloading = false;
    // },
    async updateSpecialGift(giftId, isSpecialGift) {
      this.isUpdatingSpecialGift = true;
      try {
        await axios.post('/gifts/update_special_gift', {
          gift_id: giftId,
          is_special_gift: isSpecialGift
        });
        // Refetch data to get updated values
        await this.getData();
        this.$toast.success(
          isSpecialGift 
            ? 'Gift marked as special gift successfully!' 
            : 'Gift unmarked as special gift successfully!'
        );
      } catch (error) {
        console.error('Error updating special gift:', error);
        this.$toast.error('Failed to update special gift status');
        // Revert the switch state on error
        await this.getData();
      } finally {
        this.isUpdatingSpecialGift = false;
      }
    },
  },
};
</script>
